<template>
  <div>
    <v-chip :class="[chipClass, small ? 'version-chip-small' : 'version-chip']" :color="chipColor" text-color="white" :small="small">
      <span class="font-weight-medium">{{ label }}</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'VersionTag',
  props: {
    mode: {
      type: String,
      required: true,
      validator: (value) => ['PRODUCTION', 'PREVIEW', 'HISTORY', 'NEW'].includes(value),
    },
    version: {
      type: [String, Number],
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modeConfig: {
        PRODUCTION: {
          label: () => 'Produção',
          color: 'success',
          class: 'production-chip',
        },
        PREVIEW: {
          label: () => 'Preview',
          color: 'purple',
          class: 'preview-chip',
        },
        HISTORY: {
          label: (version) => `Versão ${version}`,
          color: 'gray',
          class: 'history-chip',
        },
        NEW: {
          label: () => 'Novo',
          color: 'primary',
          class: 'new-chip',
        },
      },
    }
  },
  computed: {
    config() {
      return this.modeConfig[this.mode]
    },
    label() {
      const config = this.config
      return config.label(this.version)
    },
    chipColor() {
      return this.config.color
    },
    chipClass() {
      return this.config.class
    },
  },
}
</script>

<style lang="scss" scoped>
.version-chip {
  padding: 8px 16px !important;
  height: auto !important;
}
.production-chip {
  background: #0fc94d1a !important;
  color: #0fc94d !important;
  border: 1px solid #0fc94d40;
}

.preview-chip {
  background: #9c27b01a !important;
  color: #9c27b0 !important;
  border: 1px solid #9c27b040;
}

.history-chip {
  background: #75757520 !important;
  color: #757575 !important;
  border: 1px solid #75757540;
}

.new-chip {
  background: #0000001a !important;
  color: #000000 !important;
  border: 1px solid #00000040;
}

.production-chip span,
.preview-chip span,
.history-chip span {
  color: inherit !important;
}
</style>
